import Column from '@components/Column';
import styled from '@emotion/styled';
import useAppCustom from '@hooks/useAppCustom';
import { ItemRow } from '@models/item';
import { Link } from '@router/Link';
import { pressActionEffect } from '@styles/mixin';
import { useTranslation } from 'react-i18next';

import Badges from './Badges';
import ItemImage from './ItemImage';
import ItemText from './ItemText';

interface Props {
    shopId: string;
    item: ItemRow;
}

function Item({ item, shopId }:Props) {
    const { id } = item;
    return (
        <Link activityParams={{ shopId, itemId: id }}
            activityName='ItemActivity'
            css={pressActionEffect} >
            <Container aria-label='item'
                align='center'
                fullWidth>
                <ItemImage item={item} />
                <ItemText item={item} />
                <Badges item={item} />
            </Container>
        </Link>
    );
}

const Container = styled(Column)`
    position: relative;
`;

export default Item;
